(() => {
  if (window.lauraScottQuickView) return;
  window.lauraScottQuickView = true;

  function tidyDescriptions(scope = document) {
    scope.querySelectorAll('.product-info__description').forEach(root => {
      root.querySelectorAll('p,div,span').forEach(node => {
        if (!node.textContent.replace(/[\s\u00a0\u200b]/g, '') &&
            !node.querySelector('img,video,iframe,table,svg,hr,model-viewer,input')) node.remove();
      });
      root.querySelectorAll('br').forEach(br => {
        let previous = br.previousSibling;
        while (previous?.nodeType === 3 && !previous.textContent.trim()) previous = previous.previousSibling;
        let next = br.nextSibling;
        while (next?.nodeType === 3 && !next.textContent.trim()) next = next.nextSibling;
        if (!previous || !next || previous.nodeName === 'BR' ||
            /^(P|DIV|UL|OL|H[1-6])$/.test(previous.nodeName) ||
            /^(P|DIV|UL|OL|H[1-6])$/.test(next.nodeName)) br.remove();
      });
    });
  }
  tidyDescriptions();
  document.addEventListener('shopify:section:load', event => tidyDescriptions(event.target));

  if (document.currentScript?.dataset.quickViewEnabled !== 'true') return;

  const dialog = document.createElement('dialog');
  dialog.className = 'quick-view';
  dialog.setAttribute('aria-labelledby', 'QuickViewTitle');
  dialog.innerHTML = '<button type="button" class="quick-view__close" aria-label="Close Quick View">×</button><div class="quick-view__body"></div>';
  document.body.append(dialog);
  const body = dialog.querySelector('.quick-view__body');
  const close = dialog.querySelector('.quick-view__close');
  let opener, request, product, selected, busy = false, imageIndex = 0;

  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    request?.abort();
    document.documentElement.classList.remove('quick-view-open');
    opener?.focus({preventScroll:true});
  });
  const images = () => [...body.querySelectorAll('.quick-view__image')];
  function showImage(index) {
    const list = images();
    if (!list.length) return;
    imageIndex = (index + list.length) % list.length;
    list.forEach((image, i) => { image.hidden = i !== imageIndex; });
    body.querySelectorAll('[data-qv-photo]').forEach((dot,i) => dot.setAttribute('aria-current', String(i === imageIndex)));
  }
  function updateVariant() {
    const values = [];
    body.querySelectorAll('[data-qv-option]:checked').forEach(input => { values[Number(input.dataset.qvOption)] = input.value; });
    selected = product.variants.find(variant => variant.options.every((value,i) => !values.length || values[i] === value));
    const form = body.querySelector('form');
    const add = form.querySelector('[name="add"]');
    form.querySelector('[name="id"]').value = selected?.id || '';
    add.disabled = busy || !selected?.available;
    add.textContent = selected ? (selected.available ? product.addLabel : product.soldOutLabel) : 'Unavailable';
    if (!selected) return;
    body.querySelector('[data-qv-price]').textContent = selected.priceText;
    const compare = body.querySelector('[data-qv-compare]');
    const discount = body.querySelector('[data-qv-discount]');
    const onSale = selected.compare > selected.price;
    compare.hidden = discount.hidden = !onSale;
    compare.textContent = selected.compareText;
    discount.textContent = onSale ? Math.floor((selected.compare-selected.price)*100/selected.compare) + '% OFF' : '';
    body.querySelector('[data-qv-full]').href = product.url + '?variant=' + selected.id;
    if (selected.image) {
      const imagePath = new URL(selected.image, location.origin).pathname;
      const index = images().findIndex(image => new URL(image.src, location.origin).pathname === imagePath);
      if (index >= 0) showImage(index);
    }
  }

  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-quick-shop]');
    if (!trigger) return;
    const url = new URL(trigger.dataset.quickShop, location.origin);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    if (busy) return;
    opener = trigger;
    request?.abort();
    request = new AbortController();
    const currentRequest = request;
    busy = false;
    product = null;
    selected = null;
    body.innerHTML = '<h2 id="QuickViewTitle">Quick View</h2><p role="status">Loading…</p>';
    dialog.showModal();
    document.documentElement.classList.add('quick-view-open');
    close.focus();
    url.searchParams.set('section_id', 'quick-view');
    try {
      const response = await fetch(url, {signal:currentRequest.signal, headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error('Unable to load product.');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = parsed.querySelector('[data-quick-view-content]');
      if (!content) throw new Error('Unable to load product.');
      if (currentRequest !== request || !dialog.open) return;
      body.replaceChildren(document.importNode(content, true));
      product = JSON.parse(body.querySelector('[data-quick-view-json]').textContent);
      showImage(0);
      updateVariant();
    } catch (error) {
      if (error.name === 'AbortError' || currentRequest !== request || !dialog.open) return;
      body.innerHTML = '<h2 id="QuickViewTitle">Quick View</h2><p>We could not load this product.</p><a>View product</a>';
      url.searchParams.delete('section_id');
      body.querySelector('a').href = url.href;
    }
  });
  body.addEventListener('change', event => {
    if (event.target.matches('[data-qv-option]')) {
      body.querySelector('[data-qv-error]').hidden = true;
      updateVariant();
    }
  });
  body.addEventListener('click', event => {
    const dot = event.target.closest('[data-qv-photo]');
    if (dot) showImage(Number(dot.dataset.qvPhoto));
    if (event.target.closest('[data-qv-prev]')) showImage(imageIndex - 1);
    if (event.target.closest('[data-qv-next]')) showImage(imageIndex + 1);
  });
  let startX = null, startY = null;
  body.addEventListener('touchstart', event => {
    if (!event.target.closest('.quick-view__image-wrap')) return;
    startX = event.touches[0].clientX; startY = event.touches[0].clientY;
  }, {passive:true});
  body.addEventListener('touchend', event => {
    if (startX === null) return;
    const dx = event.changedTouches[0].clientX-startX, dy = event.changedTouches[0].clientY-startY;
    if (Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) showImage(imageIndex+(dx<0?1:-1));
    startX = startY = null;
  }, {passive:true});
  body.addEventListener('submit', async event => {
    if (!event.target.matches('[data-quick-view-form]')) return;
    event.preventDefault();
    if (busy || !selected?.available) return;
    busy = true;
    const form = event.target, add = form.querySelector('[name="add"]'), errorNode = form.querySelector('[data-qv-error]');
    const cartUrl = product.cartUrl;
    const bodyData = new FormData(form);
    errorNode.hidden = true;
    add.disabled = true;
    add.textContent = 'Adding…';
    try {
      const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), {method:'POST',body:bodyData,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      dialog.close();
      if (window.themeCartDrawer) {
        try {
          await window.themeCartDrawer.refresh();
          window.themeCartDrawer.lastActiveElement = opener;
          window.themeCartDrawer.open();
        } catch (_) { window.location.assign(cartUrl); }
      } else window.location.assign(cartUrl);
    } catch (error) {
      errorNode.textContent = error.message;
      errorNode.hidden = false;
    } finally {
      busy = false;
      if (dialog.open && product) updateVariant();
    }
  });
})();